import { stringSearch, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { IpnDetailsTabContent } from '@/areas/components/IpnDetailsPage/components/IpnDetailsTabController';
import { canViewPartLibrarySourcing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/components/ipn/_details/offers/')({
    staticData: { access: { permissions: canViewPartLibrarySourcing }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ ipnId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const ipnId = Route.useSearch({ select: (search) => search.ipnId });
    const requiredQuantity = Route.useSearch({ select: (search) => search.requiredQuantity });
    const setSearch = useSetSearch();
    return (
        <IpnDetailsTabContent
            tab={'offers'}
            ipnId={ipnId}
            pricingSearch={{ requiredQuantity, onSearchChange: setSearch }}
        />
    );
}
